import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { ResponseWrapper } from '@/shared/types/domain';
import { fetcher } from '@/shared/utils/fetcher/fetcher';

export interface FixedProduct {
  descriptionId: string;
  productShortName: string;
  thumbnailImageUrl: string | null;
  productLineBackgroundColor: string | null;
}

export const getFixedProductUrl = '/api/v1/product/description/fix-main' as const;

export function getFixMainProductListOptions() {
  return queryOptions({
    queryKey: [getFixedProductUrl],
    queryFn: () => fetcher.get<ResponseWrapper<FixedProduct[]>>(getFixedProductUrl),
  });
}

export function useGetFixMainProduct() {
  const options = getFixMainProductListOptions();
  return useSuspenseQuery(options);
}
